/**
 * DesignTokens: U6埋め込みタグの共通デザイントークン。
 * design-mockups/*.html（2026-08-06 mono.ipros.com実測トークンへ全面移行）準拠。
 *
 * 配色比率（60-30-10 Rule）: 60%=ベース（白・SURFACE_SUBTLE・TEXT_PRIMARYの本文）、
 * 30%=コントラスト（TEXT_SECONDARYの補助テキスト・BORDER_DEFAULTの枠線）、
 * 10%=アクセント（BRAND_PRIMARY）はメインCVの確定ボタン1箇所のみに厳密に限定して使用する。
 * レコメンドCV・その他のボタン・選択状態は原則グレースケール（SURFACE_SELECTED等）で表現する。
 */

/** 本文・見出し等の主要テキスト色。 */
export const TEXT_PRIMARY = "#333333";
/** 補助テキスト・注記文言の色。 */
export const TEXT_SECONDARY = "#666666";
/** プレースホルダー・非活性文言等、さらに控えめなテキスト色。 */
export const TEXT_MUTED = "#999999";

/** 枠線のデフォルト色。 */
export const BORDER_DEFAULT = "#e6e6e6";

/** モーダル・カード背景等のサブトルな面色。 */
export const SURFACE_SUBTLE = "#f9f9f9";
/** 選択済み状態の背景色（ブランドカラーを使わないグレースケール表現）。 */
export const SURFACE_SELECTED = "#f2f2f2";

/** ブランドカラー（メインCVの確定ボタン1箇所のみに限定使用）。 */
export const BRAND_PRIMARY = "#c8161d";
/** ブランドカラーのホバー時の濃色。 */
export const BRAND_PRIMARY_HOVER = "#a01218";
/** 未ログイン固定モザイクの「ログイン」ボタン背景（黒）。hover は TEXT_PRIMARY を使う（「新規会員登録」は赤背景＝BRAND_PRIMARY で別定義）。 */
export const LOGIN_BUTTON_BG = "#000000";

/** 対応形式ラベル（オンライン）の配色。 */
export const MEETING_LABEL_ONLINE_COLOR = "#245c9c";
export const MEETING_LABEL_ONLINE_BG = "#edf4fb";
export const MEETING_LABEL_ONLINE_BORDER = "#bfd6ec";

/** 対応形式ラベル（対面）の配色。 */
export const MEETING_LABEL_ONSITE_COLOR = "#27734b";
export const MEETING_LABEL_ONSITE_BG = "#edf8f1";
export const MEETING_LABEL_ONSITE_BORDER = "#c3e2cf";

/** フォントファミリー（旧「IBM Plex Mono」から「Noto Sans JP」基軸へ変更）。 */
export const FONT_FAMILY = '"Noto Sans JP", system-ui, sans-serif';

/** 角丸（全体で4pxに統一）。 */
export const RADIUS_DEFAULT = "4px";

/** モーダル・ポップオーバーの影。 */
export const SHADOW_MODAL = "0 24px 64px rgba(51,51,51,.35)";

/** 背景暗転（画面中央モーダル、ログインゲート等）。 */
export const BACKDROP_MODAL = "rgba(51,51,51,.6)";
export const BACKDROP_LOGIN_GATE = "rgba(20,20,20,.55)";

/**
 * 共通CSS変数（Shadow DOM内で`:host`に注入して利用する）。
 * 各UIファイルのCSS文字列は、直接トークン値を埋め込むか、このブロックを先頭に連結して使用する。
 */
export const DESIGN_TOKEN_CSS = `
  --spica-text-primary: ${TEXT_PRIMARY};
  --spica-text-secondary: ${TEXT_SECONDARY};
  --spica-text-muted: ${TEXT_MUTED};
  --spica-border-default: ${BORDER_DEFAULT};
  --spica-surface-subtle: ${SURFACE_SUBTLE};
  --spica-surface-selected: ${SURFACE_SELECTED};
  --spica-brand-primary: ${BRAND_PRIMARY};
  --spica-brand-primary-hover: ${BRAND_PRIMARY_HOVER};
  --spica-radius-default: ${RADIUS_DEFAULT};
  --spica-shadow-modal: ${SHADOW_MODAL};
  --spica-backdrop-modal: ${BACKDROP_MODAL};
  --spica-backdrop-login-gate: ${BACKDROP_LOGIN_GATE};
  --spica-font-family: ${FONT_FAMILY};
`;
